import { DictionaryObject, useFetch } from '@eas/common-web';
import { EvidenceApiUrl } from '@enums';

export function useExamApplicationTypes() {
  return useFetch<DictionaryObject[]>(
    `${EvidenceApiUrl.EXAM_APPLICATION}/types/list`,
    {
      method: 'GET',
      cacheResponse: true,
    }
  );
}

export function useExamApplicationStates() {
  return useFetch<DictionaryObject[]>(
    `${EvidenceApiUrl.EXAM_APPLICATION}/states/list`,
    {
      method: 'GET',
      cacheResponse: true,
    }
  );
}

export function useRetakePartTypes() {
  return useFetch<DictionaryObject[]>(
    `${EvidenceApiUrl.EXAM_APPLICATION}/retake-part-types/list`,
    {
      method: 'GET',
      cacheResponse: true,
    }
  );
}
